import {Grid, Typography} from '@mui/material';
import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';

export const Menus = () => {
  return (
    <Grid>
      <Typography variant='h6' mb={2}>
        Button Text
      </Typography>
      <RHFMultilingualField name={'menus.button.text'} />
    </Grid>
  );
};
